import { openBlock as t, createElementBlock as o, createElementVNode as e } from "vue";
const n = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
}, c = /* @__PURE__ */ e("path", {
  "fill-rule": "evenodd",
  d: "m11.793.732 3.474 3.474a.723.723 0 0 1 0 1.023L5.231 15.266a.723.723 0 0 1-.512.212H1.245a.729.729 0 0 1-.724-.724V11.28c0-.193.078-.376.213-.511L10.77.731a.728.728 0 0 1 1.023 0ZM1.97 14.03h2.45l7.576-7.575-2.451-2.451-7.576 7.575v2.451Zm8.599-11.05 2.45 2.452.715-.714-2.451-2.451-.714.714Z",
  "clip-rule": "evenodd"
}, null, -1), l = /* @__PURE__ */ e("path", { d: "M8.643 14.756c0-.399.323-.722.722-.722h4.473a.722.722 0 0 1 0 1.444H9.365a.722.722 0 0 1-.722-.722Z" }, null, -1), d = [
  c,
  l
];
function r(a, s) {
  return t(), o("svg", n, [...d]);
}
const i = { render: r };
export {
  i as default,
  r as render
};
